import { render, staticRenderFns } from "./PodCarousel.vue?vue&type=template&id=02ed6100&scoped=true&"
import script from "./PodCarousel.vue?vue&type=script&lang=js&"
export * from "./PodCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PodCarousel.vue?vue&type=style&index=0&id=02ed6100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ed6100",
  null
  
)

export default component.exports